import { components } from "@libertify/api-types/media";
import { Slide } from "pages/media/types/";
import { generateGetPositionFn } from "./itemsHelper";
import { mapTable } from "./mapTable";
import {
  mapMainImage,
  mapParameteredTexts,
  mapToFigureUnits,
} from "./mapTemplateSlidesToTemplateState";
import { MappedSlot, Slot } from "../types";

type ThemeResponse = components["schemas"]["ThemeResponse"];

export const mapThemeSlotToTemplateItems = (
  slot: Slot,
  theme: ThemeResponse | undefined,
  slide: Slide | undefined,
  slideLayoutType: string | undefined
): MappedSlot => {
  const mapped: MappedSlot = {};

  if (!theme || !slide || !slideLayoutType) return mapped;
  const layout = theme.layouts[slideLayoutType];
  if (!layout) return mapped;

  const getPosition = generateGetPositionFn(layout.layout);

  if ("parameteredTextItem" in slot && slot.parameteredTextItem) {
    const [parameteredText] = mapParameteredTexts(
      [slot.parameteredTextItem],
      getPosition,
      slide,
      true
    );
    if (parameteredText) mapped.parameteredText = parameteredText;
  }
  if ("mainImageItem" in slot && slot.mainImageItem) {
    const mainImage = mapMainImage(slot.mainImageItem, getPosition);
    if (mainImage) mapped.mainImage = mainImage;
  }
  if ("figureNumberItem" in slot && slot.figureNumberItem) {
    const [number] = mapParameteredTexts(
      [slot.figureNumberItem],
      getPosition,
      slide
    );
    if (number) mapped.figure = { number };
  }
  if ("figureUnitsItem" in slot && slot.figureUnitsItem && mapped.figure) {
    const units = mapToFigureUnits(slot.figureUnitsItem, slide, getPosition);
    if (units) mapped.figure.units = units;
  }
  if ("tableItem" in slot && slot.tableItem) {
    const table = mapTable(slot.tableItem, getPosition);
    if (table) mapped.table = table;
  }
  return mapped;
};
